export default {
  namespaced: true,
  vlm_configuration: {
    title: "VLM Configuration",
    subtitle: "Prepare a video analysis policy without sending content to external providers.",
    list_subtitle: "Manage the available video analysis configurations.",
    new_configuration: "New VLM configuration",
    edit_configuration: "Edit VLM configuration",
    add_configuration: "Add configuration",
    back_to_list: "Back to list",
    name: "Configuration name",
    name_placeholder: "E.g. North plant security",
    empty_list: "There are no VLM configurations yet.",
    delete_configuration: "Delete configuration",
    delete_confirmation: "Do you want to delete the \"{name}\" configuration? This action cannot be undone.",
    delete: "Delete",
    cancel: "Cancel",
    cameras: "Cameras",
    cameras_hint: "Select the real cameras used by this configuration.",
    prompt: "Analysis instruction",
    prompt_placeholder: "Describe what the model must identify in the video.",
    presets: "Quick examples",
    fallen_person: "Fallen person",
    fight: "Fight between people",
    disorder: "Untidy work area",
    model: "AI model",
    model_gemini_flash: "Gemini 2.5 Flash",
    model_gemini_pro: "Gemini 2.5 Pro",
    model_openai: "OpenAI GPT-5.6 Terra",
    model_gemini_description: "Native video processing for multimodal analysis.",
    model_openai_description: "Frame analysis; it does not process native video streams.",
    analysis_policy: "Analysis policy",
    enabled: "Enable VLM configuration",
    sampling_interval: "Sampling interval",
    confidence_threshold: "Confidence threshold",
    seconds: "seconds",
    summary: "Summary",
    selected_cameras: "Selected cameras",
    service_status: "Service status",
    active: "Active",
    inactive: "Inactive",
    updated_at: "Last updated",
    not_saved: "Not saved",
    save: "Save configuration",
    read_only: "You do not have permission to update this configuration.",
    load_error: "The VLM configuration could not be loaded.",
    save_error: "The VLM configuration could not be saved.",
    saved: "VLM configuration saved successfully.",
    created: "VLM configuration created successfully.",
    updated: "VLM configuration updated successfully.",
    deleted: "VLM configuration deleted successfully.",
    delete_error: "Unable to delete the VLM configuration.",
    preset_fallen: "Analyze the video and identify whether a person has fallen. Report only findings with a timestamp and confidence level.",
    preset_fight: "Analyze the video and identify possible fights or aggression between people. Report only findings with a timestamp and confidence level.",
    preset_disorder: "Analyze the video and identify untidy work areas or relevant obstructions. Report only findings with a timestamp and confidence level.",
  },
};
